import { render, staticRenderFns } from "./KeyFifteen.vue?vue&type=template&id=22db5028&scoped=true&"
import script from "./KeyFifteen.vue?vue&type=script&lang=js&"
export * from "./KeyFifteen.vue?vue&type=script&lang=js&"
import style0 from "./KeyFifteen.vue?vue&type=style&index=0&id=22db5028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22db5028",
  null
  
)

export default component.exports